import {executeOpenCommand} from '../../../_shared/GWTBridge/invoke/genPage';
import {action, actionEnd} from '../../../services/form/form';
import {Form, apiLocker, formsStore} from '../../../stores/Form';
import {priority} from '@priority-software/priority-proto-api/lib';
import {reorganizeRecordsAfterDelete} from './delete';

export const restartDirectActivation = async (session: string, ename: string) => {
    const form = formsStore.getFormBySession(session);
    const action = form.actions.find(a => a.Ename === ename);
    executeDirectActivation(form, action);
};

export const executeDirectActivation = async (form: Form, act: priority.netitems.form.IAction) => {
    const {records, session, currentRow} = form;

    const keys = records[form.currentRow].keys;
    const scrLine = currentRow;
    const actionRes = await action(session, scrLine, keys);
    // lock session manualy because all the rest of the action happens in old api that doesn't block new UI
    if (!act.Background) {
        apiLocker.lockSession(form.session);
    }
    const link = {
        link: actionRes.LinkFile,
        linkid: actionRes.LinkID,
        table: actionRes.Table
    };
    executeOpenCommand(
        act.Ename,
        String.fromCharCode(Number(act.Etype)),
        link.link,
        link.linkid,
        link.table,
        session
    );
};

export const endDirectActivation = async (session: string) => {
    const actionEndRes = await actionEnd(session);
    const form = formsStore.getFormBySession(session);
    if (actionEndRes.Record) {
        form.updateRecordValues(form.currentRow, actionEndRes.Record.Fields);
    } else {
        form.deleteClientRecord(form.currentRow);
        reorganizeRecordsAfterDelete(form);
    }
};
